export const checkIsInBetween = (number, start, end) => number >= start && number <= end;

export default checkIsInBetween;



// WEBPACK FOOTER //
// ./components/student-list/quick-selector/helpers.js